"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _expert = require("@/api/expert/expert");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "所属项目",
        type: "select",
        model: "matchId",
        options: [],
        placeholder: "所属项目",
        change: "matchChange"
      }, {
        label: "所属组别",
        type: "select",
        model: "groupId",
        options: [],
        placeholder: "所属组别",
        change: "matchChangegroup"
      }, {
        label: "所属阶段",
        type: "select",
        model: "stageId",
        options: [],
        placeholder: "所属阶段",
        change: "matchChangestage"
      }, {
        label: "名称",
        type: "input",
        model: "name",
        placeholder: "作品/课程名称"
      }, {
        label: "年份",
        type: "select",
        model: "year",
        options: [],
        placeholder: "年份"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "100"
      }, {
        name: "项目组别",
        prop: "groupName",
        isShow: true,
        width: "100"
      }, {
        name: "项目阶段",
        prop: "stageName",
        isShow: true,
        width: "100"
      }, {
        name: "作品/课程名称",
        prop: "workName",
        isShow: true,
        width: "100"
      }, {
        name: "姓名",
        prop: "userName",
        isShow: true,
        width: "100"
      }, {
        name: "状态",
        prop: "workStatus",
        isShow: true,
        width: "100",
        isFormats: true
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      expertId: ""
    };
  },
  methods: {
    // 获取该专家下的列表
    getWorksByExpert: function getWorksByExpert() {
      var _this = this;
      (0, _expert.worksByExpertId)({
        groupId: "",
        matchId: "",
        name: "",
        paegNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        stageId: ""
      }).then(function (res) {
        var data = res.data;
        _this.listData = data.list;
        _this.totalData = data.total;
      });
    },
    listBureau: function listBureau() {},
    dels: function dels() {},
    // 新增
    save: function save() {
      this.$router.push("/object/majorObject-add");
    },
    edit: function edit() {
      this.$router.push("/object/majorObject-edit");
    },
    handleSelectionChange: function handleSelectionChange() {},
    deleteById: function deleteById() {},
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getWorksByExpert();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getWorksByExpert();
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  },
  created: function created() {
    this.getWorksByExpert();
    this.expertId = this.$route.query.id;
  }
};